
import { Page, Text, View, Document, StyleSheet, Font, Image } from '@react-pdf/renderer'
import moment from 'moment'

import latoBold from '../../../fonts/Lato-Bold.ttf'
import latoRegular from '../../../fonts/Lato-Regular.ttf'

import openSansBold from '../../../fonts/open_sans/OpenSans-Bold.ttf'
import openSansSemiBold from '../../../fonts/open_sans/OpenSans-SemiBold.ttf'
import openSansMedium from '../../../fonts/open_sans/OpenSans-Medium.ttf'
import openSansRegular from '../../../fonts/open_sans/OpenSans-Regular.ttf'
import openSansLight from '../../../fonts/open_sans/OpenSans-Light.ttf'


Font.register({
    family: 'Lato',
    fonts: [
        {
            src: latoRegular
        },
        {
            src: latoBold,
            fontWeight: 'bold'
        }
    ]
});

Font.register({
    family: 'Open Sans Light',
    src: openSansLight
});

Font.register({
    family: 'Open Sans Regular',
    src: openSansRegular
});

Font.register({
    family: 'Open Sans Medium',
    src: openSansMedium
});

Font.register({
    family: 'Open Sans SemiBold',
    src: openSansSemiBold
});

Font.register({
    family: 'Open Sans Bold',
    src: openSansBold
});

const styles = StyleSheet.create({
    page: {
        fontFamily: 'Lato',
        backgroundColor: 'white',
        fontSize: 10,
        padding: 20
    },
    header: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        alignContent: 'center',
        marginTop: '10px'
    },
    infoCliente: {
        marginTop: -10
    },
    dato: {
        marginTop: 5,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    dato2: {
        marginTop: 8,
        display: 'flex',
        flexDirection: 'row'
    },
    datoObs: {
        marginTop: 5
    },
    referencia: {
        marginTop: 15,
        color: '#483B4C',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingTop: 2,
        paddingBottom: 2,
        fontSize: 10,
        fontFamily: 'Open Sans Bold'
    },
    table: {
        marginTop: 20,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderBottom: 2,
        paddingTop: 2,
        paddingBottom: 2,
        fontWeight: '400',
        color: '#483B4C'
    },
    title: {
        // marginTop: 5,
        padding: 2,
        paddingLeft: 5,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        backgroundColor: '#e8e8e8',
        color: '#14043b',
        fontStyle: 'normal',
        fontSize: 8,
        fontWeight: '600',
        textTransform: 'uppercase',
        fontFamily: 'Open Sans SemiBold'
    },
    item: {
        padding: 5,
        paddingRight: 2,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        color: '#14043b',
        fontSize: 8,
        fontWeight: '400',
        textTransform: 'uppercase',
        fontFamily: 'Open Sans Medium'
    },
    itemDesLarga: {
        marginLeft: 10,
        marginBottom: 10,
        paddingLeft: 5,
        color: '#5d5a5e',
        fontSize: 8,
        width: 260,
        fontFamily: 'Open Sans Regular',
        textAlign: 'justify'
    },
    titleDesLarga: {
        marginTop: 5,
        marginLeft: 5,
        marginBottom: 5,
        color: '#5d5a5e',
        fontSize: 8,
        width: 260,
        fontFamily: 'Open Sans Regular',
        textAlign: 'justify'
    },
    itemFechas: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        marginLeft: 10,
        marginBottom: 10,
        paddingLeft: 10,
        color: '#938a96',
        fontStyle: 'normal',
        fontSize: 9,
        fontWeight: '400'
    },
    pptoTitle: {
        color: '#8E24AA',
        fontFamily: 'Lato',
        fontSize: 12,
        textTransform: 'uppercase'
    },
    labelNameFecha: {
        color: '#483B4C',
        marginTop: 10,
        fontSize: 9,
        display: "flex",
        alignSelf: 'flex-end'
    },
    labelNameFechaRight: {
        color: '#483B4C',
        marginTop: 10,
        fontSize: 9,
        display: "flex",
        alignSelf: 'flex-start'
    },
    labelNameVersion: {
        color: '#483B4C',
        display: "flex",
        alignSelf: 'flex-end',
        fontSize: 9,
    },
    labelNameVersionRight: {
        color: '#483B4C',
        display: "flex",
        alignSelf: 'flex-start',
        fontSize: 9,
    },
    labelNameNro: {
        color: '#483B4C',
        fontSize: 11,
        marginTop: '5px',
        fontWeight: '600',
        display: "flex",
        alignSelf: 'flex-end'
    },
    labelNameNroRight: {
        color: '#483B4C',
        fontSize: 11,
        marginTop: '5px',
        fontWeight: '600',
        display: "flex",
        alignSelf: 'flex-start'
    },
    labelName: {
        color: '#483B4C',
        width: 60,
        fontSize: 9
    },
    labelName2: {
        color: '#483B4C',
        width: 100,
    },
    labelName3: {
        color: '#483B4C',
        width: 80,
    },
    labelName2Obs: {
        color: '#483B4C',
        width: 80,
    },
    labelValue: {
        color: '#78667E',
        fontSize: 8,
        textTransform: 'uppercase',
        fontFamily: 'Open Sans Regular'
    },
    labelValueAlias: {
        color: '#78667E',
        fontSize: 9,
    },
    labelValue2: {
        color: '#78667E',
        fontSize: 8,
        textTransform: 'uppercase'
    },
    labelValueObs: {
        color: '#78667E',
        fontSize: 9,
        marginTop: 10,
        marginLeft: 10,
        fontFamily: 'Open Sans Regular'
    },
    wrapTotales: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-end',
        marginTop: 15,
    },
    totales: {
        marginTop: 10,
        padding: 5,
        paddingBottom: 10,
        borderRadius: 6,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        // backgroundColor: '#FAF9FA',
        backgroundColor: '#e8e8e8',
        fontStyle: 'normal',
        fontWeight: '400',
        textTransform: 'uppercase'
    },
    labelNameTotal: {
        // color: '#483B4C',
        color: '#14043b',
        width: 130,
        textAlign: 'right',
        fontWeight: 400,
        fontSize: 8,
        fontFamily: 'Open Sans Regular'
    },
    labelValueTotal: {
        // color: '#483B4C',
        color: '#14043b',
        fontWeight: 400,
        width: 110,
        fontSize: 9,
        textAlign: 'right',
        fontFamily: 'Open Sans Regular'
    },

    labelNameTotal2: {
        // color: '#483B4C',
        color: '#14043b',
        width: 130,
        textAlign: 'right',
        // fontWeight: 400,
        fontSize: 9,
        fontFamily: 'Open Sans SemiBold'
    },
    labelValueTotal2: {
        // color: '#483B4C',
        color: '#14043b',
        // fontWeight: 400,
        width: 110,
        fontSize: 9,
        textAlign: 'right',
        fontFamily: 'Open Sans SemiBold'
    },

    labelNameIGV: {
        color: '#78667E',
        width: 130,
        textAlign: 'right',
        fontWeight: 400,
        fontSize: 9,
        textTransform: 'none'
    },
    containerLogo: {
        boxSizing: 'border-box',
        width: '160px',
        height: '150px'
    },
    imgLogo: {
        objectFit: 'contain',
        width: '100%',
        height: '100%'
    },
    newHeader: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: -30
    }
})

const formatNumber = (value = 0, currency = null, cant_decimales = 2) => {

    let country = {
        iso: 'en-US',
        currency: 'USD',
        decimales: cant_decimales || 2
    }

    if (currency === 'S/') {
        country.iso = 'es-PE'
        country.currency = 'PEN'
        country.decimales = cant_decimales || 2
    }

    const formatter = new Intl.NumberFormat(country.iso, {
        // style: 'currency',
        // currency: country.currency,
        maximumFractionDigits: country.decimales,
        minimumFractionDigits: country.decimales
    })

    // const formatter = new Intl.NumberFormat(country.iso)
    return formatter.format(value)

}

export const PdfFile = ({ auth, infoEmp, dataPreview, viewOptions, urlLogo, nombre_columna_dias, infoGeneral, imgFirma }) => {

    const { pdf_header_logo_izq, modo_arquitectura, ppto_pdf_mostrar_firma = false } = infoGeneral

    return (
        <Document>

            <Page
                size="A4"
                style={styles.page}
                wrap={true}
            >

                {pdf_header_logo_izq ?
                    <HeaderLogoLeft
                        info={infoEmp}
                        infoGeneral={infoGeneral}
                        urlLogo={urlLogo}
                        dataPreview={dataPreview}
                    />
                    :
                    <HeaderLogoRight
                        info={infoEmp}
                        infoGeneral={infoGeneral}
                        urlLogo={urlLogo}
                        dataPreview={dataPreview}
                    />
                }

                <InfoCliente
                    auth={auth}
                    info={dataPreview}
                    infoGeneral={infoGeneral}
                />

                <View style={styles.referencia}>
                    <Text style={{ textTransform: 'uppercase' }}>{dataPreview.referencia}</Text>
                </View>

                {modo_arquitectura &&
                    <View style={[styles.infoCliente, { marginTop: '2px' }]}>
                        {dataPreview?.ubicacion ?
                            <View style={styles.dato}>
                                <Text style={styles.labelName3}>Ubicación:</Text>
                                <Text style={styles.labelValue2}>{dataPreview?.ubicacion || '--'}</Text>
                            </View> : ''
                        }
                        {dataPreview?.area_construida ?
                            <View style={styles.dato}>
                                <Text style={styles.labelName3}>Área :</Text>
                                <Text style={styles.labelValue2}>{dataPreview?.area_construida || '--'}{' '}{dataPreview?.medida_construida || 'MT2'}</Text>
                            </View> : ''

                        }
                    </View>
                }

                <Items
                    info={dataPreview}
                    viewOptions={viewOptions}
                    nombre_columna_dias={nombre_columna_dias}
                    infoGeneral={infoGeneral}
                />

                <Totales
                    info={dataPreview}
                    viewOptions={viewOptions}
                    infoGeneral={infoGeneral}
                />

                <Condiciones
                    info={dataPreview}
                    infoGeneral={infoGeneral}
                />

                <DatosEmpresa
                    info={infoEmp}
                    infoGeneral={infoGeneral}
                />

                {(ppto_pdf_mostrar_firma && viewOptions.mostrar_firma) &&
                    <View style={{ marginTop: '30px', marginBottom: '10px', breakInside: "avoid" }} wrap={false}>
                        <Image
                            style={{ width: '80px', height: 'auto', marginBottom: '-42px' }}
                            src={imgFirma} Text
                            alt="firma"
                        />
                        <Text>- - - - - - - - - - - - - - - - - - - - -</Text>
                        <Text style={{ fontSize: '8px', fontWeight: 'bold' }}>ARQ DIANA BEJARANO PEÑA</Text>
                        <Text style={{ fontSize: '8px' }}>GERENTE GENERAL</Text>
                    </View>
                }

            </Page>

        </Document >
    )
}

const Items = ({ info, viewOptions, nombre_columna_dias, infoGeneral }) => {

    const { pdf_color_formato, ppto_items_ocultar_dias, ppto_items_ocultar_dscto, ppto_cant_decimales } = infoGeneral
    const { nombre_columna_dias: columnName } = info

    return (
        <>

            <View style={[styles.table, { borderBottomColor: pdf_color_formato ? pdf_color_formato : '#8E24AA' }]}>
                <Text style={{ width: 400, textAlign: 'left' }}>Ítems</Text>
                {(!viewOptions.ocultar_montos_items && !(viewOptions.ver_solo_subtotal_item || viewOptions.ver_solo_subtotal_titulos)) &&
                    <Text style={{ width: 100, textAlign: 'center' }}>Cant.</Text>
                }
                {(!viewOptions.ocultar_montos_items && !(viewOptions.ver_solo_subtotal_item || viewOptions.ver_solo_subtotal_titulos) && !ppto_items_ocultar_dias) &&
                    <Text style={{ width: 100, textAlign: 'center', textTransform: 'capitalize' }}>{columnName || 'Días'}</Text>
                }
                {(!viewOptions.ocultar_montos_items && !(viewOptions.ver_solo_subtotal_item || viewOptions.ver_solo_subtotal_titulos) && !viewOptions.ver_solo_titulos) &&
                    <Text style={{ width: 100, textAlign: 'center' }}>Unid</Text>
                }
                {(!viewOptions.ocultar_montos_items && !(viewOptions.ver_solo_subtotal_item || viewOptions.ver_solo_subtotal_titulos)) &&
                    <Text style={{ width: 100, textAlign: 'right' }}>P. Unitario</Text>
                }
                {!viewOptions.ocultar_montos_items &&
                    <Text style={{ width: 100, textAlign: 'right' }}>Subtotal</Text>
                }
                {(!viewOptions.ocultar_montos_items && !(viewOptions.ver_solo_subtotal_item || viewOptions.ver_solo_subtotal_titulos) && !ppto_items_ocultar_dscto) &&
                    <Text style={{ width: 100, textAlign: 'right' }}>Dscto.</Text>
                }
                {(!viewOptions.ocultar_montos_items && !ppto_items_ocultar_dscto) &&
                    <Text style={{ width: 100, textAlign: 'right' }}>Total</Text>
                }
            </View >

            {info?.items?.filter(it => it.ocultar_item_print !== true)?.map((title, index) => {
                return (
                    <View>

                        <View style={{ breakInside: "avoid" }} wrap={false}>

                            <View style={[styles.title, { breakInside: "avoid" }]} wrap={false}>

                                <Text style={{ width: 400, textAlign: 'left' }}>
                                    <Text style={{ marginLeft: 50 }}>{(index + 1)}.</Text>
                                    <Text style={{ marginLeft: 100 }}>{"  "}{title.nombre}</Text>
                                </Text>

                                {(!viewOptions.ocultar_montos_items && !(viewOptions.ver_solo_subtotal_item || viewOptions.ver_solo_subtotal_titulos)) &&
                                    <Text style={{ width: 100, textAlign: 'center' }}></Text>
                                }
                                {(!viewOptions.ocultar_montos_items && !(viewOptions.ver_solo_subtotal_item || viewOptions.ver_solo_subtotal_titulos) && !ppto_items_ocultar_dias) &&
                                    <Text style={{ width: 100, textAlign: 'center' }}></Text>
                                }
                                {(!viewOptions.ocultar_montos_items && !(viewOptions.ver_solo_subtotal_item || viewOptions.ver_solo_subtotal_titulos) && !viewOptions.ver_solo_titulos) &&
                                    <Text style={{ width: 100, textAlign: 'center' }}></Text>
                                }
                                {(!viewOptions.ocultar_montos_items && !(viewOptions.ver_solo_subtotal_item || viewOptions.ver_solo_subtotal_titulos)) &&
                                    <Text style={{ width: 100, textAlign: 'right' }}>
                                        {/* {formatNumber(title.precio_unitario, info.simbolo)} */}
                                    </Text>
                                }
                                {(!viewOptions.ocultar_montos_items && !ppto_items_ocultar_dscto) &&
                                    <Text style={{ width: 100, textAlign: 'right' }}>
                                        {/* {formatNumber(title.pre_subtotal_precio, info.simbolo)} */}
                                        {`${info.simbolo}${' '}${formatNumber(title.pre_subtotal_precio, info.simbolo)}`}
                                    </Text>
                                }
                                {(!viewOptions.ocultar_montos_items && !(viewOptions.ver_solo_subtotal_item || viewOptions.ver_solo_subtotal_titulos) && !ppto_items_ocultar_dscto) &&
                                    <Text style={{ width: 100, textAlign: 'right' }}>
                                        {`${info.simbolo}${' '}${formatNumber(title.descuento, info.simbolo)}`}
                                    </Text>
                                }
                                {!viewOptions.ocultar_montos_items &&
                                    <Text style={{ width: 100, textAlign: 'right' }}>
                                        {`${info.simbolo}${' '}${formatNumber(title.precio_subtotal, info.simbolo)}`}
                                    </Text>
                                }
                            </View>
                            {
                                (title.descripcion_larga && title.descripcion_larga !== '') &&
                                <View style={[styles.titleDesLarga, { breakInside: "avoid" }]} wrap={false}>
                                    <Text>{title.descripcion_larga}</Text>
                                </View>
                            }
                        </View>

                        {
                            !viewOptions.ver_solo_titulos && title.items?.filter(ti => ti.ocultar_item_print !== true)?.map((item, index2) => (
                                <View style={{ breakInside: "avoid" }} wrap={false}>

                                    <View style={styles.item}>
                                        <Text style={{ width: 400, textAlign: 'left' }}>
                                            <Text style={{ marginLeft: 50 }}>{' '}{' '}{(index + 1)}.{index2 + 1}.</Text>
                                            <Text style={{ marginLeft: 100 }}>{"  "}{item.nombre}</Text>
                                        </Text>
                                        {(!viewOptions.ocultar_montos_items && !(viewOptions.ver_solo_subtotal_item || viewOptions.ver_solo_subtotal_titulos)) &&
                                            <Text style={{ width: 100, textAlign: 'center' }}>{item.cant}</Text>
                                        }
                                        {(!viewOptions.ocultar_montos_items && !(viewOptions.ver_solo_subtotal_item || viewOptions.ver_solo_subtotal_titulos) && !ppto_items_ocultar_dias) &&
                                            <Text style={{ width: 100, textAlign: 'center' }}>{item.dias}</Text>
                                        }
                                        {(!viewOptions.ocultar_montos_items && !(viewOptions.ver_solo_subtotal_item || viewOptions.ver_solo_subtotal_titulos) && !viewOptions.ver_solo_titulos) &&
                                            <Text style={{ width: 100, textAlign: 'center' }}>{item.unidad_medida}</Text>
                                        }
                                        {(!viewOptions.ocultar_montos_items && !(viewOptions.ver_solo_subtotal_item || viewOptions.ver_solo_subtotal_titulos)) &&
                                            <Text style={{ width: 100, textAlign: 'right' }}>
                                                {/* {formatNumber(item.precio_unitario, info.simbolo, ppto_cant_decimales)} */}
                                                {`${info.simbolo}${' '}${formatNumber(item.precio_unitario, info.simbolo, ppto_cant_decimales)}`}
                                            </Text>
                                        }
                                        {(!viewOptions.ocultar_montos_items && !ppto_items_ocultar_dscto) &&
                                            <Text style={{ width: 100, textAlign: 'right' }}>
                                                {/* {formatNumber(item.pre_subtotal_precio, info.simbolo)} */}
                                                {`${info.simbolo}${' '}${formatNumber(item.pre_subtotal_precio, info.simbolo)}`}
                                            </Text>
                                        }
                                        {(!viewOptions.ocultar_montos_items && !(viewOptions.ver_solo_subtotal_item || viewOptions.ver_solo_subtotal_titulos) && !ppto_items_ocultar_dscto) &&
                                            <Text style={{ width: 100, textAlign: 'right' }}>
                                                {/* {formatNumber(item.descuento, info.simbolo, ppto_cant_decimales)} */}
                                                {`${info.simbolo}${' '}${formatNumber(item.descuento, info.simbolo)}`}
                                            </Text>
                                        }
                                        {(!viewOptions.ocultar_montos_items && !viewOptions.ver_solo_subtotal_titulos) &&
                                            <Text style={{ width: 100, textAlign: 'right' }}>
                                                {/* {formatNumber(item.precio_subtotal, info.simbolo)} */}
                                                {`${info.simbolo}${' '}${formatNumber(item.precio_subtotal, info.simbolo)}`}
                                            </Text>
                                        }
                                    </View>

                                    {(item.descripcion_larga && item.descripcion_larga !== '') &&
                                        <View style={styles.itemDesLarga}>
                                            <Text>{item.descripcion_larga}</Text>
                                        </View>
                                    }

                                    {(item.fecha_inicio) &&
                                        <View style={styles.itemFechas}>
                                            <Text>F. Inicio: {moment(item.fecha_inicio).format('DD-MM-YYYY')}</Text>
                                            <Text style={{ marginLeft: '10px' }}>F. Término: {moment(item.fecha_fin).format('DD-MM-YYYY')}</Text>
                                        </View>
                                    }
                                </View>
                            ))
                        }
                    </View >
                )
            })}

        </>
    )
}

const InfoCliente = ({ auth, info, infoGeneral }) => {

    const { ppto_pdf_ocultar_enviado_por = false } = infoGeneral

    return (
        <>
            <View style={styles.infoCliente}>
                <View style={styles.dato}>
                    <Text style={styles.labelName}>Cliente:</Text>
                    <Text style={styles.labelValue}>{info?.razon_social || (info?.cliente || '--')}</Text>
                </View>

                {parseInt(info?.contacto_id) > 0 &&
                    <View style={styles.dato}>
                        <Text style={styles.labelName}>Para:</Text>
                        <Text style={styles.labelValue}>{info?.contacto_nombre || '--'}</Text>
                    </View>
                }

                <View style={styles.dato}>
                    <Text style={styles.labelName}>Email:</Text>
                    <Text style={[styles.labelValue]}>{info?.contacto_email || '--'}</Text>
                </View>

                {!ppto_pdf_ocultar_enviado_por &&
                    <>
                        {(auth.alias !== '' && auth.alias !== null && auth.alias_mostrar === true) ?
                            <View style={styles.dato}>
                                <Text style={styles.labelName}>Enviado por:</Text>
                                <Text style={styles.labelValueAlias}>{`${auth.alias || '--'} / ${auth.email || '--'}`}</Text>
                            </View>
                            :
                            <View style={styles.dato}>
                                <Text style={styles.labelName}>Enviado por:</Text>
                                <Text style={styles.labelValue}>{`${auth.name || '--'} / ${auth.email || '--'}`}</Text>
                            </View>
                        }
                    </>
                }

            </View >
        </>
    )
}

const Totales = ({ info, viewOptions, infoGeneral }) => {

    const { texto_no_incluye_igv } = infoGeneral

    return (
        <View style={[styles.wrapTotales, { breakInside: "avoid" }]} wrap={false}>
            <View style={{ width: '50%' }}></View>
            <View style={[styles.totales, { width: '50%' }]}>

                {(info.descuento > 0 || (info.sobrecargo_gg_porcentaje > 0 || info.sobrecargo_utilidad_porcentaje > 0)) &&
                    <View style={styles.dato2}>
                        <Text style={styles.labelNameTotal}>SUBTOTAL</Text>
                        <Text style={styles.labelValueTotal}>
                            {`${info.simbolo}${' '}${formatNumber(info.sub_total, info.simbolo)}`}
                        </Text>
                    </View>
                }

                {info.descuento > 0 &&
                    <View style={styles.dato2}>
                        <Text style={styles.labelNameTotal}>({info.descuento_porcentaje}%)  DESC</Text>
                        <Text style={styles.labelValueTotal}>
                            {`${info.simbolo}${' '}${formatNumber(info.descuento, info.simbolo)}`}
                        </Text>
                    </View>
                }

                {info.descuento > 0 &&
                    <View style={styles.dato2}>
                        <Text style={styles.labelNameTotal}>SUBTOTAL CON DSCTO.</Text>
                        <Text style={styles.labelValueTotal}>
                            {`${info.simbolo}${' '}${formatNumber((info.sub_total - info.descuento), info.simbolo)}`}
                        </Text>
                    </View>
                }

                {info.sobrecargo_gg_porcentaje > 0 &&
                    <View style={styles.dato2}>
                        <Text style={styles.labelNameTotal}>Gastos Generales ({info.sobrecargo_gg_porcentaje}%)</Text>
                        <Text style={styles.labelValueTotal}>
                            {`${info.simbolo}${' '}${formatNumber(info.sobrecargo_gg, info.simbolo)}`}
                        </Text>
                    </View>
                }

                {info.sobrecargo_utilidad_porcentaje > 0 &&
                    <View style={styles.dato2}>
                        <Text style={styles.labelNameTotal}>Utilidad ({info.sobrecargo_utilidad_porcentaje}%)</Text>
                        <Text style={styles.labelValueTotal}>
                            {`${info.simbolo}${' '}${formatNumber(info.sobrecargo_utilidad, info.simbolo)}`}
                        </Text>
                    </View>
                }

                <View style={styles.dato2}>
                    <Text style={styles.labelNameTotal2}>{viewOptions.ocultar_texto_igv ? 'TOTAL' : 'TOTAL NETO'}</Text>
                    <Text style={styles.labelValueTotal2}>
                        {/* {formatNumber(info.total_cliente, info.simbolo)} */}
                        {`${info.simbolo}${' '}${formatNumber(info.total_cliente, info.simbolo)}`}
                    </Text>
                </View>

                {viewOptions.ver_total_con_impuestos &&
                    <>
                        <View style={styles.dato2}>

                            {parseInt(info.id_tipo_documento) === 4 ?
                                <Text style={styles.labelNameTotal}>( {info.porcentaje_impuesto}% )  IR</Text>
                                :
                                <Text style={styles.labelNameTotal}>( {info.porcentaje_impuesto}% )  IGV</Text>
                            }

                            <Text style={styles.labelValueTotal}>
                                {/* {formatNumber(info.total_impuesto, info.simbolo)} */}
                                {`${info.simbolo}${' '}${formatNumber(info.total_impuesto, info.simbolo)}`}
                            </Text>
                        </View>
                        <View style={styles.dato2}>
                            <Text style={styles.labelNameTotal}>TOTAL</Text>
                            <Text style={styles.labelValueTotal}>
                                {/* {formatNumber(info.total, info.simbolo)} */}
                                {`${info.simbolo}${' '}${formatNumber(info.total, info.simbolo)}`}
                            </Text>
                        </View>
                    </>
                }

                {(!viewOptions.ver_total_con_impuestos && !viewOptions.ocultar_texto_igv) &&
                    <View style={styles.dato2}>
                        {(texto_no_incluye_igv && !texto_no_incluye_igv !== '') ?
                            <Text style={styles.labelNameIGV}>{texto_no_incluye_igv}</Text>
                            :
                            <Text style={styles.labelNameIGV}>No incluye IGV</Text>
                        }
                    </View>
                }

            </View>
        </View >
    )
}

const Condiciones = ({ info, infoGeneral }) => {

    const { pdf_color_formato, ppto_ocultar_tc } = infoGeneral

    /*const limpiarTexto = (texto) => {
        return texto
            .normalize("NFKC")
            // eslint-disable-next-line no-control-regex
            .replace(/[\u0000-\u001F\u007F]/g, "")
            .trim();
    }*/

    const limpiarTexto = (texto) => {
        return texto
            // eslint-disable-next-line no-control-regex
            .normalize("NFKC")
            .replace(/\r\n/g, "\n")              // Windows → Unix
            .replace(/\r/g, "\n")                // Mac antiguo → Unix
            .replace(/\u00A0/g, " ")             // Espacio no separable
            .replace(/[\u200B-\u200D\uFEFF]/g, "") // Invisibles
            .replace(/[ \t]+/g, " ")             // Espacios múltiples (NO toca \n)
            .trim();

    }


    return (
        <View style={{ breakInside: "avoid" }} wrap={false}>
            <View
                style={[
                    styles.table,
                    {
                        borderBottomColor: pdf_color_formato ? pdf_color_formato : '#8E24AA',
                        marginBottom: 10,
                        breakInside: "avoid"
                    }
                ]}
                wrap={false}
            >
                <Text>CONDICIONES</Text>
            </View>

            <View style={[styles.dato, { breakInside: "avoid" }]} wrap={false}>
                <Text style={styles.labelName2}>Moneda:</Text>
                <Text style={styles.labelValue}>
                    {info.moneda || '--'}
                </Text>
            </View>

            <View style={[styles.dato, { breakInside: "avoid" }]} wrap={false}>
                <Text style={styles.labelName2}>Forma de pago:</Text>
                <Text style={styles.labelValue}>{info.forma_pago || '--'}</Text>
            </View>

            {
                (info.fecha_vencimiento && info.fecha_vencimiento !== '') &&
                <View style={[styles.dato, { breakInside: "avoid" }]} wrap={false}>
                    <Text style={styles.labelName2}>Fecha vencimiento:</Text>
                    <Text style={styles.labelValue}>{moment(info.fecha_vencimiento).format('DD-MM-YYYY') || '--'}</Text>
                </View>
            }

            <View style={[styles.datoObs, { breakInside: "avoid" }]} wrap={false}>
                <Text style={styles.labelName2Obs}>Observaciones:</Text>
                <Text style={styles.labelValueObs}>{limpiarTexto(info?.observaciones) || '--'}</Text>
            </View>

            {
                (info.no_incluye && info.no_incluye !== '') &&
                <View style={[styles.datoObs, { marginTop: 10, breakInside: "avoid" }]} wrap={false}>
                    <Text style={styles.labelName2Obs}>No Incluye:</Text>
                    <Text style={styles.labelValueObs}>{limpiarTexto(info?.no_incluye) || '--'}</Text>
                </View>
            }

            {
                (info.terminos_condiciones && info.terminos_condiciones !== '' && !ppto_ocultar_tc) &&
                <View style={[styles.datoObs, { marginTop: 10, breakInside: "avoid" }]} wrap={false}>
                    <Text style={[styles.labelName2Obs, { width: 200 }]}>Términos y condiciones:</Text>
                    <Text style={styles.labelValueObs}>{limpiarTexto(info?.terminos_condiciones) || '--'}</Text>
                </View>
            }

        </View >
    )
}

const DatosEmpresa = ({ info, infoGeneral }) => {

    const { pdf_color_formato } = infoGeneral

    return (
        <View style={{ breakInside: "avoid" }} wrap={false}>
            <View style={[styles.table, { borderBottomColor: pdf_color_formato ? pdf_color_formato : '#8E24AA', marginBottom: 10 }]}>
                <Text>DATOS DE EMPRESA</Text>
            </View>
            <View style={styles.dato}>
                <Text style={styles.labelName2}>Razón social:</Text>
                <Text style={styles.labelValue}>{info.razon_social}</Text>
            </View>
            <View style={styles.dato}>
                <Text style={styles.labelName2}>RUC:</Text>
                <Text style={styles.labelValue}>{info.ruc}</Text>
            </View>
            <View style={styles.dato}>
                <Text style={styles.labelName2}>Dirección:</Text>
                <Text style={styles.labelValue}>{info.direccion}</Text>
            </View>
            <View style={styles.dato}>
                <Text style={styles.labelName2}>Teléfono:</Text>
                <Text style={styles.labelValue}>{info.fono}</Text>
            </View>
            <View style={styles.dato}>
                <Text style={styles.labelName2}>Página web:</Text>
                <Text style={[styles.labelValue, { textTransform: 'lowercase' }]}>{info.sitio_web}</Text>
            </View>
        </View>
    )
}

const HeaderLogoLeft = ({ info, infoGeneral, urlLogo, dataPreview }) => {

    const { pdf_color_formato, ppto_pdf_nombre_ppto } = infoGeneral

    return (
        <View style={styles.newHeader}>
            <View style={styles.containerLogo}>
                <Image
                    style={styles.imgLogo}
                    src={urlLogo}
                    alt="logo"
                />
            </View>
            <View>
                {pdf_color_formato ?
                    <Text style={{
                        color: pdf_color_formato,
                        fontFamily: 'Lato',
                        fontSize: 12,
                        textTransform: 'uppercase',
                        fontWeight: 'Bold',
                    }}>
                        {ppto_pdf_nombre_ppto ? ppto_pdf_nombre_ppto : 'PRESUPUESTO'}
                    </Text>
                    :
                    <Text style={styles.pptoTitle}>
                        {ppto_pdf_nombre_ppto ? ppto_pdf_nombre_ppto : 'PRESUPUESTO'}
                    </Text>
                }
                <Text style={styles.labelNameNro}>{`#${dataPreview.folio}`}</Text>
                <Text style={styles.labelNameFecha}>{moment(new Date()).format('DD MMMM YYYY')}</Text>

                {(dataPreview?.nro_version_actual > 0) &&
                    <Text style={styles.labelNameVersion}>Versión {dataPreview?.nro_version_actual || 1}</Text>
                }

            </View>
        </View>
    )
}

const HeaderLogoRight = ({ info, infoGeneral, urlLogo, dataPreview }) => {

    const { pdf_color_formato, ppto_pdf_nombre_ppto, ppto_pdf_folio_con_fecha = false } = infoGeneral

    return (
        <View style={styles.newHeader}>
            <View>
                {pdf_color_formato ?
                    <Text style={{
                        color: pdf_color_formato,
                        fontFamily: 'Lato',
                        fontSize: 12,
                        textTransform: 'uppercase',
                        fontWeight: 'Bold',
                    }}>
                        {ppto_pdf_nombre_ppto ? ppto_pdf_nombre_ppto : 'PRESUPUESTO'}
                    </Text>
                    :
                    <Text style={styles.pptoTitle}>
                        {ppto_pdf_nombre_ppto ? ppto_pdf_nombre_ppto : 'PRESUPUESTO'}
                    </Text>
                }

                {ppto_pdf_folio_con_fecha ?
                    <Text style={[styles.labelNameNroRight, {}]}>{`N° ${moment(dataPreview.fecha_asignacion).format('YYYY')}-${dataPreview.numero}`}</Text>
                    :
                    <Text style={[styles.labelNameNroRight, {}]}>{`N° ${dataPreview.folio}`}</Text>
                }

                <Text style={styles.labelNameFechaRight}>{moment(new Date()).format('DD MMMM YYYY')}</Text>

                {(dataPreview?.nro_version_actual > 0) &&
                    <Text style={styles.labelNameVersionRight}>Versión {dataPreview?.nro_version_actual || 1}</Text>
                }

            </View>
            <View style={styles.containerLogo}>
                <Image
                    style={styles.imgLogo}
                    src={urlLogo}
                    alt="logo"
                />
            </View>
        </View>
    )
}